import {AlertFilters} from '../../types/interfaces';

export class FetchParamsList {
  static readonly type = '[AlertFilters] Fetch All';

  constructor(public payload: AlertFilters) {
  }
}
